import * as angular from 'angular';
import * as _ from 'lodash';

import { Dashboard, IRouteWithParameters } from '../../models';
import { dashboardRouteName, guidGroupValidationPageLink, validationPageRouteName } from '../../common/constants';

export interface IDashboardHelperService {
    getGotoDestination(destinationDashboardGuid: string, dashboards?: { [guid: string]: Dashboard }, groupGuidToSelect?: string, beginDate?: string, endDate?: string): IRouteWithParameters;
    getSelectedGroupGuid(selectedGuid: string, item?: any, dashboards?: Dashboard[]): string;
    getDashboardNames(dashboards: Dashboard[] | _.Dictionary<Dashboard>): _.Dictionary<string>;
}

export class DashboardHelperService implements IDashboardHelperService {
    static serviceId: string = 'dashboardHelperService';

    static $inject = [
        '$translate'
    ];

    constructor(
        private _$translate: angular.translate.ITranslateService
    ) { }

    getGotoDestination(destinationDashboardGuid: string, dashboards?: { [guid: string]: Dashboard }, groupGuidToSelect?: string, beginDate?: string, endDate?: string): IRouteWithParameters {
        let route: IRouteWithParameters;
        const parameters: {
            dashboardName?: string;
            groupGuid?: string;
            beginDate?: string | null;
            endDate?: string | null;
        } = {
            beginDate: null,
            endDate: null
        };
        if (beginDate) {
            parameters.beginDate = beginDate;
        }
        if (endDate) {
            parameters.endDate = endDate;
        }
        // Link to validation page
        if (destinationDashboardGuid === guidGroupValidationPageLink) {
            parameters.groupGuid = groupGuidToSelect;
            route = {
                route: validationPageRouteName,
                params: parameters
            };
            // Link to dashboard
        } else {
            parameters.dashboardName = destinationDashboardGuid;
            const destinationDashboard = _.find(dashboards, d => d.guid === destinationDashboardGuid);
            const hasGroupTypes = destinationDashboard
                && destinationDashboard.groupTypes
                && destinationDashboard.groupTypes.length > 0;
            const hasGroups = destinationDashboard
                && destinationDashboard.groupGuids
                && destinationDashboard.groupGuids.length > 0;
            parameters.groupGuid = ((hasGroupTypes || hasGroups) && groupGuidToSelect)
                ? groupGuidToSelect
                : null;
            route = {
                route: dashboardRouteName,
                params: parameters
            };
        }
        return route;
    }

    getSelectedGroupGuid(selectedGuid: string, item?: any, dashboards?: Dashboard[]): string {
        let guid: string = '';
        // From table widget
        if (item && item.originalViewModel) {
            guid = item.originalViewModel.objectType === 1
                ? item.originalViewModel.groupList[0].guid
                : selectedGuid;
        }
        // From tileDisplay
        else if (item && selectedGuid && dashboards) {
            guid = this.getTileGroupGuid(dashboards, guid, item);
        }
        // From widgetsList
        else if (item) {
            guid = item?.selectedGroupGuid ?? selectedGuid;
        }
        // From flowChart or validation state
        else if (selectedGuid) {
            guid = selectedGuid;
        }
        return guid;
    }

    private getTileGroupGuid(dashboards: Dashboard[], guid: string, item: any) {
        const dashboardFound = _.find(dashboards, d => d.guid === guid);
        if (dashboardFound?.groupTypes && dashboardFound.groupTypes.length > 0) {
            if (item.ggroupGuidroupList && item.groupList.length > 0) {
                if (item.groupList[0].guid) {
                    guid = item.groupList[0].guid;
                }
            }
        }
        return guid;
    }

    getDashboardNames(dashboards: Dashboard[] | _.Dictionary<Dashboard>): _.Dictionary<string> {
        let dashboardNames;
        if (dashboards && Array.isArray(dashboards)) {
            dashboardNames = (Object as any).assign({}, ...(dashboards as Dashboard[]).map(d => ({ [d.guid]: d.name })));
        } else {
            dashboardNames = (Object as any).assign({}, ...(_.values(dashboards) as Dashboard[]).map(d => ({ [d.guid]: d.name })));
        }
        dashboardNames[guidGroupValidationPageLink] = this._$translate.instant('Group validation page');
        return dashboardNames;
    }
}